'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requirementDataRequested = requirementDataRequested;
exports.requirementDataReceived = requirementDataReceived;
exports.requirementDataRequestFailed = requirementDataRequestFailed;
var REQUIREMENT_DATA_REQUESTED = exports.REQUIREMENT_DATA_REQUESTED = 'REQUIREMENT_DATA_REQUESTED';

function requirementDataRequested() {
    return {
        type: REQUIREMENT_DATA_REQUESTED
    };
}

var REQUIREMENT_DATA_RECEIVED = exports.REQUIREMENT_DATA_RECEIVED = 'REQUIREMENT_DATA_RECEIVED';

function requirementDataReceived(requirementData) {
    return {
        type: REQUIREMENT_DATA_RECEIVED,
        requirementData: requirementData
    };
}

var REQUIREMENT_DATA_REQUEST_FAILED = exports.REQUIREMENT_DATA_REQUEST_FAILED = 'REQUIREMENT_DATA_REQUEST_FAILED';

function requirementDataRequestFailed(error) {
    return {
        type: REQUIREMENT_DATA_REQUEST_FAILED,
        error: error
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/requirementDataActions.js
// module id = 87
// module chunks = 0